<script>
    export default {
        props: ['page'],
        data() {
            return {
                scale: 0.8
            }
        },

        computed: {
            actualSizeViewport() {
                return this.viewport.clone({ scale: this.scale });
            },

            canvasStyle() {
                const { width: actualSizeWidth, height: actualSizeHeight } = this.actualSizeViewport;
                const pixelRatio = window.devicePixelRatio || 1;
                const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight].map(dim => Math.ceil(dim / pixelRatio));
                //return `width: ${pixelWidth}px; height: ${pixelHeight}px;`
                return `max-width: 100%; height: auto;`
            },
            canvasAttrs() {
                let { width, height } = this.viewport;
                [width, height] = [width, height].map(dim => Math.ceil(dim));

                const style = this.canvasStyle;

                return {
                    width,
                    height,
                    style,
                    class: 'pdf-page'
                };
            },
            pageNumber() {
                return this.page.pageNumber;
            }
        },
        methods: {
            renderPage() {
                // PDFPageProxy#render
                // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
                this.renderTask = this.page.render(this.getRenderContext());
                this.renderTask.promise.then(() => this.$emit('rendered', this.page));
            },
            destroyPage(page) {
                if (!page) return;
                // PDFPageProxy#_destroy
                // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
                page._destroy();
                // RenderTask#cancel
                // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
                if (this.renderTask) this.renderTask.cancel();
            },
            getRenderContext() {
                const { viewport } = this;
                const canvasContext = this.$el.getContext('2d');
                return { canvasContext, viewport };
            },
        },
        watch: {
            page(page, oldPage) {
                this.destroyPage(oldPage);
            },
        },
        created() {
            // PDFPageProxy#getViewport
            // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
            this.viewport = this.page.getViewport({ scale: this.scale});
        },
        mounted() {
            //log(`Page ${this.pageNumber} mounted`);
            this.renderPage();
        },
        beforeDestroy() {
            this.destroyPage(this.page);
        },
        render(h) {
            const { canvasAttrs: attrs } = this;
            return h('canvas', { attrs });
        },
    }

</script>
